import { render, staticRenderFns } from "./EditorHelpImage.vue?vue&type=template&id=255242fc"
import script from "./EditorHelpImage.vue?vue&type=script&lang=js"
export * from "./EditorHelpImage.vue?vue&type=script&lang=js"
import style0 from "./EditorHelpImage.vue?vue&type=style&index=0&id=255242fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports